// Mock data pour enovationweb.com

export const services = [
  {
    id: 'web-creation',
    title: 'Création de Sites Web',
    slug: 'creation-sites-web',
    icon: 'Globe',
    shortDescription: 'Des sites web sur-mesure qui convertissent vos visiteurs en clients.',
    fullDescription: 'Nous concevons et développons des sites web modernes, rapides et optimisés pour la conversion. De la vitrine corporate à la plateforme e-commerce, nous créons des expériences digitales qui reflètent votre marque.',
    features: [
      'Sites vitrine et corporate',
      'E-commerce et marketplaces',
      'Applications web personnalisées',
      'Design responsive et mobile-first',
      'Optimisation des performances',
      'Maintenance et support continu'
    ],
    benefits: [
      'Augmentation de la visibilité en ligne',
      'Meilleure expérience utilisateur',
      'Taux de conversion optimisé',
      'Interface intuitive et moderne'
    ],
    color: '#059669',
    bgLight: '#d1fae5'
  },
  {
    id: 'ai-solutions',
    title: 'Intelligence Artificielle',
    slug: 'intelligence-artificielle',
    icon: 'Brain',
    shortDescription: 'Intégrez l\'IA pour automatiser et optimiser vos processus métier.',
    fullDescription: 'Nous développons des solutions d\'intelligence artificielle sur-mesure pour automatiser vos tâches, analyser vos données et améliorer votre productivité. Chatbots, analyse prédictive, traitement du langage naturel et plus encore.',
    features: [
      'Chatbots intelligents et assistants virtuels',
      'Analyse de données et prédictions',
      'Traitement du langage naturel (NLP)',
      'Vision par ordinateur',
      'Automatisation des processus',
      'Intégration d\'APIs IA (GPT, Claude, Gemini)'
    ],
    benefits: [
      'Réduction des coûts opérationnels',
      'Disponibilité 24/7 pour vos clients',
      'Décisions basées sur les données',
      'Gain de temps considérable'
    ],
    color: '#10b981',
    bgLight: '#ecfdf5'
  },
  {
    id: 'seo',
    title: 'Référencement SEO',
    slug: 'referencement-seo',
    icon: 'TrendingUp',
    shortDescription: 'Positionnez votre site en première page de Google et augmentez votre trafic.',
    fullDescription: 'Notre expertise SEO vous garantit une visibilité maximale sur les moteurs de recherche. Audit complet, optimisation technique, stratégie de contenu et netlinking pour des résultats durables.',
    features: [
      'Audit SEO complet et technique',
      'Recherche et analyse de mots-clés',
      'Optimisation on-page et off-page',
      'Stratégie de contenu SEO',
      'Netlinking et backlinks de qualité',
      'Suivi et rapports mensuels'
    ],
    benefits: [
      'Visibilité accrue sur Google',
      'Trafic organique qualifié',
      'ROI mesurable et durable',
      'Autorité de domaine renforcée'
    ],
    color: '#047857',
    bgLight: '#f0fdf4'
  },
  {
    id: 'sea',
    title: 'Publicité SEA',
    slug: 'publicite-sea',
    icon: 'Target',
    shortDescription: 'Campagnes publicitaires Google Ads et social media pour des résultats immédiats.',
    fullDescription: 'Nous créons et gérons vos campagnes publicitaires sur Google Ads, Facebook, Instagram et LinkedIn. Ciblage précis, optimisation continue et ROI maximisé pour votre budget marketing.',
    features: [
      'Campagnes Google Ads (Search, Display, Shopping)',
      'Publicité sur réseaux sociaux (Meta, LinkedIn)',
      'Remarketing et retargeting',
      'Optimisation du taux de conversion',
      'A/B testing et analyses',
      'Gestion budgétaire optimisée'
    ],
    benefits: [
      'Résultats immédiats et mesurables',
      'Ciblage précis de votre audience',
      'ROI optimisé',
      'Augmentation des conversions'
    ],
    color: '#065f46',
    bgLight: '#ecfdf5'
  },
  {
    id: 'social-media',
    title: 'Gestion Réseaux Sociaux',
    slug: 'gestion-reseaux-sociaux',
    icon: 'Share2',
    shortDescription: 'Développez votre présence sociale et engagez votre communauté.',
    fullDescription: 'Nous gérons vos réseaux sociaux de A à Z : stratégie de contenu, création graphique, community management et analyse des performances. Construisez une communauté engagée autour de votre marque.',
    features: [
      'Stratégie social media sur-mesure',
      'Création de contenu visuel et rédactionnel',
      'Planification et publication',
      'Community management',
      'Campagnes d\'influence',
      'Analytics et reporting'
    ],
    benefits: [
      'Notoriété de marque accrue',
      'Engagement client renforcé',
      'Trafic qualifié vers votre site',
      'Fidélisation de la communauté'
    ],
    color: '#10b981',
    bgLight: '#d1fae5'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sophie Martin',
    company: 'Directrice Marketing - TechStart SAS',
    content: 'Enovation du Web a transformé notre présence en ligne. Notre site web génère maintenant 3x plus de leads qualifiés. Une équipe professionnelle et réactive !',
    rating: 5,
    avatar: 'SM'
  },
  {
    id: 2,
    name: 'Marc Dubois',
    company: 'CEO - Innovatech Solutions',
    content: 'Leur expertise en IA nous a permis d\'automatiser 60% de notre support client. ROI exceptionnel en moins de 6 mois. Je recommande vivement !',
    rating: 5,
    avatar: 'MD'
  },
  {
    id: 3,
    name: 'Caroline Leroy',
    company: 'Fondatrice - BioBeauté Paris',
    content: 'Grâce à leur stratégie SEO et réseaux sociaux, nos ventes en ligne ont augmenté de 250%. Une équipe qui comprend vraiment les enjeux business.',
    rating: 5,
    avatar: 'CL'
  }
];

export const stats = [
  {
    id: 1,
    value: '150+',
    label: 'Projets Réalisés'
  },
  {
    id: 2,
    value: '98%',
    label: 'Clients Satisfaits'
  },
  {
    id: 3,
    value: '12 ans',
    label: 'D\'Expérience'
  },
  {
    id: 4,
    value: '24/7',
    label: 'Support Client'
  }
];

export const teamMembers = [
  // Direction
  {
    id: 1,
    name: 'M. DOMINIC',
    role: 'CEO',
    department: 'Direction',
    bio: 'Visionnaire et leader de l\'agence',
    avatar: 'MD',
    photo: 'https://customer-assets.emergentagent.com/job_agency-platform-22/artifacts/9pj9u88h_IMG_1815_modifi%C3%A9.JPG'
  },
  
  // Service Technique
  {
    id: 2,
    name: 'Amine Ben Youssef',
    role: 'Responsable technique (CTO)',
    department: 'Service Technique',
    bio: 'Expert en architecture et innovation technologique',
    avatar: 'ABY',
    photo: 'https://images.pexels.com/photos/4183516/pexels-photo-4183516.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
  },
  {
    id: 3,
    name: 'Yasmine Trabelsi',
    role: 'Cheffe de projets digitaux',
    department: 'Service Technique',
    bio: 'Gestion de projets complexes et coordination d\'équipes',
    avatar: 'YT',
    photo: 'https://images.unsplash.com/photo-1758518727888-ffa196002e59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHdvbWFuJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc0MjA1ODE1fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 4,
    name: 'Karim Gharbi',
    role: 'Développeur Full Stack',
    department: 'Service Technique',
    bio: 'Expert React, Node.js et bases de données',
    avatar: 'KG',
    photo: 'https://images.pexels.com/photos/4687544/pexels-photo-4687544.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
  },
  {
    id: 5,
    name: 'Sarra Ben Amor',
    role: 'Développeuse Front-End',
    department: 'Service Technique',
    bio: 'Spécialiste UI/UX et frameworks modernes',
    avatar: 'SBA',
    photo: 'https://images.unsplash.com/photo-1655249493799-9cee4fe983bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHdvbWFuJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc0MjA1ODE1fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 6,
    name: 'Walid Ksibi',
    role: 'Développeur Back-End',
    department: 'Service Technique',
    bio: 'Expert API, microservices et cloud',
    avatar: 'WK',
    photo: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&q=80'
  },
  {
    id: 7,
    name: 'Nourhene Jebali',
    role: 'UX/UI Designer',
    department: 'Service Technique',
    bio: 'Design thinking et expériences utilisateur mémorables',
    avatar: 'NJ',
    photo: 'https://images.unsplash.com/photo-1655249481446-25d575f1c054?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHdvbWFuJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc0MjA1ODE1fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 8,
    name: 'Hatem Chaari',
    role: 'Développeur Mobile',
    department: 'Service Technique',
    bio: 'Applications iOS et Android natives',
    avatar: 'HC',
    photo: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&q=80'
  },
  {
    id: 9,
    name: 'Meriem Khlifi',
    role: 'QA Tester / Testeuse qualité',
    department: 'Service Technique',
    bio: 'Garantie qualité et tests automatisés',
    avatar: 'MK',
    photo: 'https://images.unsplash.com/photo-1581065178047-8ee15951ede6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHdvbWFuJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc0MjA1ODE1fDA&ixlib=rb-4.1.0&q=85'
  },
  
  // Service Marketing
  {
    id: 10,
    name: 'Ines Mansouri',
    role: 'Responsable Marketing Digital',
    department: 'Service Marketing',
    bio: 'Stratégie digitale et croissance',
    avatar: 'IM',
    photo: 'https://images.pexels.com/photos/7580822/pexels-photo-7580822.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
  },
  {
    id: 11,
    name: 'Rania Ben Salem',
    role: 'Social Media Manager',
    department: 'Service Marketing',
    bio: 'Gestion et stratégie réseaux sociaux',
    avatar: 'RBS',
    photo: 'https://images.pexels.com/photos/36363694/pexels-photo-36363694.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
  },
  {
    id: 12,
    name: 'Asma Bouazizi',
    role: 'Content Manager',
    department: 'Service Marketing',
    bio: 'Création de contenu engageant et viral',
    avatar: 'AB',
    photo: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&q=80'
  },
  {
    id: 13,
    name: 'Hanen Dammak',
    role: 'Chargée de communication digitale',
    department: 'Service Marketing',
    bio: 'Communication corporate et brand image',
    avatar: 'HD',
    photo: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&q=80'
  },
  {
    id: 14,
    name: 'Syrine Ghedira',
    role: 'Spécialiste SEO',
    department: 'Service Marketing',
    bio: 'Optimisation et référencement naturel',
    avatar: 'SG',
    photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80'
  },
  {
    id: 15,
    name: 'Mariem Baccar',
    role: 'Traffic Manager (SEA / Ads)',
    department: 'Service Marketing',
    bio: 'Campagnes publicitaires et ROI optimisé',
    avatar: 'MB',
    photo: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&q=80'
  },
  {
    id: 16,
    name: 'Oumaima Ayari',
    role: 'Community Manager',
    department: 'Service Marketing',
    bio: 'Animation de communautés et engagement',
    avatar: 'OA',
    photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&q=80'
  },
  {
    id: 17,
    name: 'Khalil Mejri',
    role: 'Chargé de partenariats & influence',
    department: 'Service Marketing',
    bio: 'Partenariats stratégiques et marketing d\'influence',
    avatar: 'KM',
    photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&q=80'
  },
  
  // Service Administratif
  {
    id: 18,
    name: 'Faten Sassi',
    role: 'Responsable RH & Administratif',
    department: 'Service Administratif',
    bio: 'Gestion RH et développement des talents',
    avatar: 'FS',
    photo: 'https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=400&q=80'
  },
  {
    id: 19,
    name: 'Mohamed Ali Kooli',
    role: 'Comptable',
    department: 'Service Administratif',
    bio: 'Gestion financière et comptabilité',
    avatar: 'MAK',
    photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80'
  },
  {
    id: 20,
    name: 'Leila Ben Hmida',
    role: 'Assistante administrative',
    department: 'Service Administratif',
    bio: 'Support administratif et organisation',
    avatar: 'LBH',
    photo: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&q=80'
  }
];

export const caseStudies = [
  {
    id: 1,
    client: 'Luxe & Déco',
    industry: 'E-commerce',
    service: 'Création Web + SEO',
    results: '+320% de trafic organique en 8 mois',
    description: 'Refonte complète du site e-commerce avec optimisation SEO avancée.',
    image: null,
    color: '#059669'
  },
  {
    id: 2,
    client: 'MediCare Pro',
    industry: 'Santé',
    service: 'Chatbot IA',
    results: '60% de réduction des appels support',
    description: 'Développement d\'un assistant virtuel intelligent pour la prise de rendez-vous.',
    image: null,
    color: '#10b981'
  },
  {
    id: 3,
    client: 'Fashion Avenue',
    industry: 'Mode',
    service: 'Social Media + SEA',
    results: '+450% de ROI publicitaire',
    description: 'Campagnes multi-plateformes avec ciblage précis et contenu viral.',
    image: null,
    color: '#047857'
  }
];

export const faqData = [
  {
    id: 1,
    question: 'Combien de temps faut-il pour créer un site web ?',
    answer: 'Le délai varie selon la complexité du projet. Un site vitrine prend généralement 3-4 semaines, tandis qu\'une plateforme e-commerce peut nécessiter 8-12 semaines. Nous établissons un planning détaillé dès le début du projet.'
  },
  {
    id: 2,
    question: 'Quels sont vos tarifs ?',
    answer: 'Nos tarifs sont adaptés à chaque projet. Un site vitrine commence à partir de 2 500€, un site e-commerce à partir de 8 000€. Nous proposons également des forfaits mensuels pour le SEO, SEA et la gestion des réseaux sociaux. Contactez-nous pour un devis personnalisé gratuit.'
  },
  {
    id: 3,
    question: 'Proposez-vous la maintenance des sites web ?',
    answer: 'Oui, nous offrons des contrats de maintenance incluant mises à jour de sécurité, sauvegardes régulières, support technique et optimisations continues. Plusieurs formules sont disponibles selon vos besoins.'
  },
  {
    id: 4,
    question: 'Comment mesurez-vous les résultats de vos campagnes SEO/SEA ?',
    answer: 'Nous utilisons des outils professionnels (Google Analytics, Search Console, etc.) et vous fournissons des rapports mensuels détaillés avec KPIs clairs : trafic, conversions, ROI, positions de mots-clés, et recommandations d\'optimisation.'
  },
  {
    id: 5,
    question: 'Puis-je mettre à jour mon site moi-même ?',
    answer: 'Absolument ! Nous intégrons un système de gestion de contenu (CMS) intuitif qui vous permet de modifier textes, images et pages sans compétences techniques. Nous vous formons également à son utilisation.'
  }
];
